import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { AnalysePage } from "@/pages/analyse";

export const Route = createFileRoute("/$lang/analyse")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/analyse",
      title: t("analyse.title"),
      description: t("analyse.description"),
    });
  },
  component: AnalysePage,
});
